import React, {useState, useEffect, useRef} from "react";
import GenericTemplate from "../../templates/GenericTemplate";
import {
  apollo_useStyles,
  apollo_useRowStyles,
  valueToOption,
  options_matchtype,
  option_setpoint_cv_category,
  option_setpoint_action_category,
} from "../../atom/Apollo_styles";
import {ApolloAuthorization} from "../../atom/Apollo_Authorization";
import {ApolloBreadcrumbs} from "../../atom/Apollo_Breadcrumbs";

import {Link, useHistory, useParams} from "react-router-dom";
import Select from 'react-select';

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Fab from "@material-ui/core/Fab";
import Tooltip from '@material-ui/core/Tooltip';

import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions/CardActions";

import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";

import {ApolloContext} from "../../atom/Apollo_Context";
import axios from "axios";
import moment from "moment";
import {ApolloMessage, CustomizedSnackbars} from "../../atom/Apollo_Mesasge";
import {Attention, DeleteButton} from "../../molecule/Apollo_Button";

import {
  Event,
  SetPoint,
  UrlPattern,
  SetPointCategoryUpdateRequest,
  SetPointActiveUpdateRequest,
} from "./HeraModel"

import {hera_setpoints_path, hera_events_path, herasetpoints_path} from "../../atom/Apollo_links"

import {ApolloEventRecord, LogData, ItemList} from "../../atom/Apollo_EventRecord";
import { options_state_setpoint } from "./common/CommonConst";
import { ApiResponse, ApolloAxios, getResultType, isSuccessApi } from "../../atom/Apollo_ApiRequest3";
import ActiveDialog from "./common/ActiveDialog";

// エラーメッセージ
const ERROR_MESSAGE = [
  "データの取得に失敗しました",
];
// 警告メッセージ
const WARNING_MESSAGE = [
  "有効可能上限数を超えてしまうため、ステータスを「有効」にすることができません。他の有効な測定ポイントのステータスを「無効」にしてから、再度設定してください。",
]

const valueToLabel = function (value: any, options: Array<{ value: any; label: string }>): string {
  let option = options.find(option => option.value === value)
  if (!option) {
    return ""
  } else {
    return option.label
  }
}

function TagRow(props: { row: UrlPattern}) {
  const {row} = props;
  const classes = apollo_useRowStyles();
  return (
    <React.Fragment>
      <TableRow className={classes.root}>
        <TableCell align="left">{row.pattern}</TableCell>
        <TableCell align="left">{valueToLabel(row.matchType, options_matchtype)}</TableCell>
      </TableRow>
    </React.Fragment>
  );
}

function ExternalRow(props: {rowString: string}) {
  const {rowString} = props;
  const classes = apollo_useRowStyles();
  return (
    <React.Fragment>
      <TableRow className={classes.root}>
        <TableCell align="left">{rowString}</TableCell>
      </TableRow>
    </React.Fragment>
  );
}

const HeraSetPointDetail: React.FC = () => {
  const classes = apollo_useStyles();
  let history = useHistory();

  const {state} = React.useContext(ApolloContext);
  const trackerId = state.current.trackerId

  // 0: 新規　、　id：編集
  const {setPointId} = useParams<{ setPointId: string; }>();

  const initSetPoint: SetPoint = {
    ID: 0,
    name: "",
    isActive: true,
    cv_category: 1,
    action_category: 1,
    attribute: {
      attributeType: 0,
      tag: {
        eventID: 0,
        urlTarget: true,
        urlPatterns: [],
      },
      externalMeasureTool: {
        eventParameter: "",
      }
    },
  }

  const initEvent: Event = {
    ID: 0,
    name: "",
    latestRecord: "",
  }

  const [setPoint, setSetPoint] = useState<SetPoint>(initSetPoint)
  const [event, setEvent] = useState<Event>(initEvent)
  const [isCategoryEditor, setIsCategoryEditor] = useState<boolean>(false);
  const beforeSetPoint = useRef<SetPoint>(initSetPoint)

  const {data, setmsg} = React.useContext(ApolloMessage);
  const processing = useRef(false);
  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    const fetchSetPoint = async () => {
      setmsg({
        type: "loading",
        payload: {
          ...data,
          loading: true
        }
      })
      const url = `${process.env.REACT_APP_API_ENDPOINT}${hera_setpoints_path}/${trackerId}/${setPointId}`
      await axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${state.accesstoken}`,
        }
      })
        .then((response) => {
          if (response.data.resultCode !== -1) {
            const result: SetPoint = response.data.result;
            if ((result.cv_category ?? 0) === 0 || (result.action_category ?? 0) === 0) {
              result.cv_category = option_setpoint_cv_category[0].value
              result.action_category = option_setpoint_action_category[0].value
              setIsCategoryEditor(true);
            }
            setSetPoint(result);
            beforeSetPoint.current = result;
          } else {
            setmsg({
              type: "setMessage",
              payload: {
                ...data,
                open: true,
                type: "error",
                message: ERROR_MESSAGE[0]
              }
            });
          }
        })
        .catch(err => {
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: ERROR_MESSAGE[0]
            }
          });
        })
        .finally(() => {
          setmsg({
            type: "loading",
            payload: {
              ...data,
              loading: false
            }
          })
        })
    }
    fetchSetPoint();
  }, [])
  useEffect(() => {
    const fetchEvent = async () => {
      setmsg({
        type: "loading",
        payload: {
          ...data,
          loading: true
        }
      })
      const url = `${process.env.REACT_APP_API_ENDPOINT}${hera_events_path}/${trackerId}/${setPoint.attribute.tag.eventID}`
      axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${state.accesstoken}`,
        }
      })
        .then((response) => {
          if (response.data.resultcode === 0) {
            setEvent(response.data.result)
          } else {
            setmsg({
              type: "setMessage",
              payload: {
                ...data,
                open: true,
                type: "error",
                message: ERROR_MESSAGE[0]
              }
            });
          }
        })
        .catch((error) => {
          
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: ERROR_MESSAGE[0]
            }
          });
        })
        .finally(() => {
          setmsg({
            type: "loading",
            payload: {
              ...data,
              loading: false
            }
          })
        })
    }
    if (setPoint.ID !== 0 && setPoint?.attribute?.attributeType == 2) {
      fetchEvent();
    }
  }, [setPoint])
  let products = [
    {name: 'トラッカーID', desc: 'tracker id', value: trackerId},
    {name: '測定ポイントID', desc: 'setpoint id', value: setPoint.ID},
    {name: '測定ポイント名', desc: 'setpoint name', value: setPoint.name},
    {name: 'ステータス', desc: 'isActive name', value: setPoint.isActive},
    {name: 'CVカテゴリ', desc: 'setpoint cv category', value: valueToOption(setPoint.cv_category, option_setpoint_cv_category).label},
    {name: 'アクションカテゴリ', desc: 'setpoint action category', value: valueToOption(setPoint.action_category, option_setpoint_action_category).label},
    {name: 'イベント名', desc: 'イベント名称', value: event.name},
  ];
  if (setPoint?.attribute?.attributeType == 1) {
    products = [
      {name: 'トラッカーID', desc: 'tracker id', value: trackerId},
      {name: '測定ポイントID', desc: 'setpoint id', value: setPoint.ID},
      {name: '測定ポイント名', desc: 'setpoint name', value: setPoint.name},
      {name: 'ステータス', desc: 'isActive name', value: setPoint.isActive},
      {name: 'CVカテゴリ', desc: 'setpoint cv category', value: valueToOption(setPoint.cv_category, option_setpoint_cv_category).label},
      {name: 'アクションカテゴリ', desc: 'setpoint action category', value: valueToOption(setPoint.action_category, option_setpoint_action_category).label},
    ];
  }

  const handleChangeCvCategory = (event: any) => {
    setSetPoint({
      ...setPoint,
      cv_category: event.value,
    })
  };

  const handleChangeActionCategory = (event: any) => {
    setSetPoint({
      ...setPoint,
      action_category: event.value,
    })
  };

  const handleChangeStatus = (event: any) => {
    setSetPoint({
      ...setPoint,
      isActive: event.value,
    })
  };

  const handleSaveStatus = async () => {
    if (beforeSetPoint.current.isActive && !setPoint.isActive) {
      setOpen(true);
    } else {
      await handleSaveStatusExecute();
    }
  };

  const handleSaveStatusExecute = async() => {
    if (processing.current) return;
    processing.current = true;
    let isSuccess = false;

    let itemList: ItemList[] = [
      {
        key: "ステータス",
        beforeValue: valueToOption(beforeSetPoint.current.isActive, options_state_setpoint).label,
        afterValue: valueToOption(setPoint.isActive, options_state_setpoint).label,
      },
    ]

    // 実行時ログ
    const executionLog: LogData = {
      eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
      logType: "execute",
      result: "",
      userID: state.userprofile.userId,
      userName: state.userprofile.userName,
      accessToken: state.accesstoken ,
      accountGroupID : state.current.accountGroupId,
      accountGroupName: state.current.accountGroupName,
      accountID : state.current.accountId,
      accountName: state.current.accountName,
      campaignID: "", // キャンペーンID
      campaignName: "", // キャンペーン名
      adGroupID: "", // 広告グループID
      adGroupName: "", // 広告グループ名
      menu: "",
      displayName: "測定ポイント詳細画面",
      category: "測定ポイント",
      actionType: "更新",
      targetID: setPointId,
      targetName: setPoint.name,
      itemList: itemList,
    }
    ApolloEventRecord(executionLog);

    const url = `${hera_setpoints_path}/${trackerId}/${setPointId}/active`
    const apiBody: SetPointActiveUpdateRequest = {
      isActive: setPoint.isActive,
    }

    await ApolloAxios.patch(url, apiBody).then(response => {
      const res: ApiResponse = response.data
      if (!isSuccessApi(res.resultCode)) {
        const type: string = response?.data?.message === "有効可能上限数エラー" ? "warning" : getResultType(res.resultCode)
        const message: string = response?.data?.message === "有効可能上限数エラー" ? WARNING_MESSAGE[0] : `ステータス更新に失敗しました。${res?.message ?? ""}`
        return Promise.reject({
          open: true,
          type: type,
          errmsg: message,
        });
      }

      isSuccess = true;
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "success",
          message: "ステータス更新に成功しました。"
        }
      });
    }).catch(err => {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: err.type,
          message: err.errmsg,
        }
      });
    }).finally(() => {
      const resultLog: LogData = {
        ...executionLog,
        eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
        logType: "result",
        result: isSuccess? "成功" : "失敗",
      }
      ApolloEventRecord(resultLog);

      processing.current = false;
      if (isSuccess) {
        const url = `${herasetpoints_path}`
        history.push(url);
      }
    });
  }

  const handleSaveCategory = async() => {
    if (processing.current) return;
    let isSuccess = false;
    processing.current = true;

    let itemList: ItemList[] = [
      {
        key: "CVカテゴリ",
        beforeValue: "",
        afterValue: valueToOption(setPoint.cv_category, option_setpoint_cv_category).label,
      },
      {
        key: "アクションカテゴリ",
        beforeValue: "",
        afterValue: valueToOption(setPoint.action_category, option_setpoint_action_category).label,
      },
    ]

    // 実行時ログ
    const executionLog: LogData = {
      eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
      logType: "execute",
      result: "",
      userID: state.userprofile.userId,
      userName: state.userprofile.userName,
      accessToken: state.accesstoken ,
      accountGroupID : state.current.accountGroupId,
      accountGroupName: state.current.accountGroupName,
      accountID : state.current.accountId,
      accountName: state.current.accountName,
      campaignID: "", // キャンペーンID
      campaignName: "", // キャンペーン名
      adGroupID: "", // 広告グループID
      adGroupName: "", // 広告グループ名
      menu: "",
      displayName: "測定ポイント詳細画面",
      category: "測定ポイント",
      actionType: "更新",
      targetID: setPoint.ID + "",
      targetName: setPoint.name,
      itemList: itemList,
    }
    ApolloEventRecord(executionLog);

    const updateRequest: SetPointCategoryUpdateRequest = {
      cv_category: setPoint.cv_category,
      action_category: setPoint.action_category,
    }

    const url = `${process.env.REACT_APP_API_ENDPOINT}${hera_setpoints_path}/${trackerId}/${setPointId}/category`;
    await axios.patch(url, updateRequest, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${state.accesstoken}`,
      }
    }).then(response => {
      if (response.data.resultcode === 0) {
        isSuccess = true;
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "success",
            message: "測定ポイント更新に成功しました"
          }
        });
      }
    }).catch(err => {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "測定ポイント更新に失敗しました"
        }
      });
    }).finally(() => {
      const resultLog: LogData = {
        ...executionLog,
        eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
        logType: "result",
        result: isSuccess? "成功" : "失敗",
      }
      ApolloEventRecord(resultLog);

      processing.current = false;
      if (isSuccess) {
        history.goBack();
      }
    });
  }

  const handleDelete = async () => {
    if (processing.current) return;
    processing.current = true;
    let isSuccess = false;

    // 実行時ログ
    const executionLog: LogData = {
      eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
      logType: "execute",
      result: "",
      userID: state.userprofile.userId,
      userName: state.userprofile.userName,
      accessToken: state.accesstoken ,
      accountGroupID : state.current.accountGroupId,
      accountGroupName: state.current.accountGroupName,
      accountID : state.current.accountId,
      accountName: state.current.accountName,
      campaignID: "", // キャンペーンID
      campaignName: "", // キャンペーン名
      adGroupID: "", // 広告グループID
      adGroupName: "", // 広告グループ名
      menu: "",
      displayName: "測定ポイント詳細画面",
      category: "測定ポイント",
      actionType: "削除",
      targetID: setPoint.ID + "",
      targetName: setPoint.name,
      itemList: [],
    }
    ApolloEventRecord(executionLog);

    const url = `${process.env.REACT_APP_API_ENDPOINT}${hera_setpoints_path}/${trackerId}/${setPointId}`
    await axios.delete(url, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${state.accesstoken}`,
      }
    })
      .then((response) => {
        if (response.data.resultcode === 0) {
          isSuccess = true;
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "success",
              message: "削除に成功しました"
            }
          });
        } else {
          console.log(response.data.message);
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: "削除に失敗しました"
            }
          });
        }
      })
      .catch((error) => {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: "削除に失敗しました"
          }
        });
      })
      .finally(() => {
        // 実行結果ログ
        const resultLog: LogData = {
          ...executionLog,
          eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
          logType: "result",
          result: isSuccess? "成功" : "失敗",
        }
        ApolloEventRecord(resultLog);

        processing.current = false;

        if (isSuccess) {
          const url = `${herasetpoints_path}`
          history.push(url);
          }
      });
  };

  const handelGoback = () => {
    const url = `${herasetpoints_path}`
    history.push(url);
  };

  const attention: Attention = {
    message: "※削除後は効果測定対象外となりますのでご注意ください",
    style: {color: "red"}
  }

  return (
    <GenericTemplate title="">
      <ApolloBreadcrumbs bread_no={54} zeusaccountid={0} zeuscampaignid={0} adgroupid={0} adid={0} query={""}
                         platform={""}/>
      <CustomizedSnackbars/>
      <ApolloAuthorization role={10}>
        <Tooltip title="測定ポイント削除" placement="top">
          <Fab color="primary" aria-label="del" className={classes.fab}>
            <DeleteButton handleDelete={handleDelete} title="測定ポイント削除" text={`${setPoint.name}を削除しますか？`} attention={attention}/>
          </Fab>
        </Tooltip>
      </ApolloAuthorization>
      <React.Fragment>
        <Card className={classes.root} square variant="outlined">
          <CardContent>
            <Box my={3}>
              <Grid container spacing={3}>
                {products?.map((product, index) => (
                  <React.Fragment key={index}>
                    <Grid item xs={6}>
                      <Typography>{product.name}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      {(() => {
                        if (product.name === "CVカテゴリ") {
                          return (
                            isCategoryEditor
                              ? <Select
                                id="cvCategory"
                                name="cvCategory"
                                options={option_setpoint_cv_category}
                                defaultValue={option_setpoint_cv_category[0]}
                                value={setPoint.cv_category ? option_setpoint_cv_category.find((v) => v.value === setPoint.cv_category) : option_setpoint_cv_category[0]}
                                onChange={handleChangeCvCategory}
                              />
                              : valueToOption(setPoint.cv_category, option_setpoint_cv_category).label
                          );
                        } else if (product.name === "アクションカテゴリ") {
                          return (
                            isCategoryEditor
                              ? <Select
                                id="actionCategory"
                                name="actionCategory"
                                options={option_setpoint_action_category}
                                menuPosition="fixed"
                                defaultValue={option_setpoint_action_category[0]}
                                value={setPoint.action_category ? option_setpoint_action_category.find((v) => v.value === setPoint.action_category) : option_setpoint_action_category[0]}
                                onChange={handleChangeActionCategory}
                              />
                              : valueToOption(setPoint.action_category, option_setpoint_action_category).label
                          );
                        } else if (product.name === "ステータス") {
                          return (
                            <Select
                              id="isActive"
                              name="isActive"
                              options={options_state_setpoint}
                              menuPosition="fixed"
                              defaultValue={options_state_setpoint[0]}
                              value={options_state_setpoint.find((v) => v.value === setPoint.isActive)}
                              onChange={handleChangeStatus}
                            />
                          )
                        } else {
                          return (<Typography>{product.value}</Typography>);
                        }
                      })()}
                    </Grid>
                  </React.Fragment>
                ))}
              </Grid>
            </Box>
            <Typography variant="subtitle1" gutterBottom>
              測定条件
            </Typography>
            <TableContainer component={Paper} square variant="outlined">
              <Table size="small" aria-label="purchases">
                <TableHead>
                  {setPoint?.attribute?.attributeType == 2 &&
                  <TableRow>
                    <TableCell align="left">指定URL</TableCell>
                    <TableCell align="left">URLパターン</TableCell>
                  </TableRow>
                  }
                  {setPoint?.attribute?.attributeType == 1 &&
                  <TableRow>
                    <TableCell align="left">計測地点識別パラメータ名</TableCell>
                  </TableRow>
                  }
                </TableHead>
                <TableBody>
                  {setPoint?.attribute?.attributeType == 2 && setPoint?.attribute?.tag?.urlPatterns?.map((row, index: number) => (
                    <TagRow key={index} row={row} />
                  ))}
                  {setPoint?.attribute?.attributeType == 1 && 
                    <ExternalRow key={0} rowString={setPoint?.attribute?.externalMeasureTool?.eventParameter} />
                  }
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
          <CardActions className={classes.cardaction}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSaveStatus}
              className={classes.button}
              disabled={processing.current}
            >
              ステータス更新
            </Button>
            {isCategoryEditor
              ? <Button
                variant="contained"
                color="primary"
                onClick={handleSaveCategory}
                className={classes.button}
                disabled={processing.current}
              >
                カテゴリ更新
              </Button>
              : ""
            }
            <Button
              variant="contained"
              color="primary"
              onClick={handelGoback}
              className={classes.button}
            >
              戻る
            </Button>
          </CardActions>
        </Card>
      </React.Fragment>

      <ActiveDialog
        open={open}
        type={"setpoint"}
        name={setPoint.name}
        handleSave={handleSaveStatusExecute}
        handleClose={() => {setOpen(false)}}
      />
    </GenericTemplate>
  );
};

export default HeraSetPointDetail;
